import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isImageFile } from '../mime-type';

/**
 * Angular pipe that checks if a value is an image File object.
 *
 * Example:
 * ```html
 * @if (file | isImageMimeType) {
 *   <div>This is an image file</div>
 * }
 * ```
 */
@Pipe({
  name: 'isImageFile',
})
export class IsImageFilePipe implements PipeTransform {
  transform(
    value: unknown,
  ): value is
    | (File & { type: 'image/jpeg' })
    | (File & { type: 'image/png' })
    | (File & { type: 'image/gif' })
    | (File & { type: 'image/svg+xml' })
    | (File & { type: 'image/webp' })
    | (File & { type: 'image/bmp' })
    | (File & { type: 'image/tiff' }) {
    return isImageFile(value);
  }
}
